import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import i18next from "i18next";
import { useParams } from "react-router-dom";
import { Meta } from "../../Components/Helpers/Meta";

const Climate = () => {
    const { t } = useTranslation();
    const language = i18next.language;
    const { lang } = useParams();


    // useEffect(() => {
    //   if (lang) {
    //       i18next.changeLanguage(lang);
    //   }
    //   const updateTitle = () => {
    //       document.title = `${t("environmentalpolicyandactivities")} - Cevher`;
    //     };

    //     updateTitle();

    //     const handleLanguageChanged = () => {
    //       updateTitle();
    //     };

    //     i18next.on("languageChanged", handleLanguageChanged);

    //     return () => {
    //       i18next.off("languageChanged", handleLanguageChanged);
    //     };
    //   }, [lang]);

    return (
        <div>
            <Meta title={t("climate-policy-title")} description={t("climate-policy-1")} lang={lang} />
            <Navbar />
            <div className="c-wrapper">
                <div className="c-hero">
                    <div className="c-hero-background">
                        <picture>
                            <img
                                className="c-hero-image"
                                alt=""
                                src={require("../../assets/hero/climate-photo.jpg")}
                            />
                        </picture>
                    </div>
                    <div className="c-hero-body">
                        <div className="c-about-caption">
                            <div
                                className="c-caption-section"
                                style={{ color: "#fff", textAlign: "center" }}
                            >
                                {t("sustainability")}
                            </div>
                            <h1 className="c-caption-header">
                                {t("climate-policy-title")}
                            </h1>
                        </div>
                    </div>
                </div>
                <div
                    className="c-container"
                    style={{ paddingTop: "3rem", paddingBottom: "3rem" }}
                >
                    <p>
                        <br />
                        <strong style={{ textAlign: "start" }}>{t("climate-policy-title")}</strong>
                    </p>
                    <p>
                        <br />
                        {t("climate-policy-1")}
                    </p>
                    <p>

                        {t("climate-policy-2")}
                    </p>
                    <p>

                        {t("climate-policy-3")}
                    </p>
                    <p>

                        {t("climate-policy-4")}
                    </p>
                    <p>

                        {t("climate-policy-5")}
                    </p>

                    <p>
                        <br />
                        <strong style={{ textAlign: "start" }}>{t("climate-policy-title-1.1")}</strong>
                    </p>
                    <p>
                        <br />
                        <strong style={{ textAlign: "start" }}>{t("climate-policy-title-2")}</strong>
                    </p>

                    <br />
                    <ul style={{ listStyle: "inside" }}>
                        <li>{t("climate-policy-2.1")}</li>
                        <li>
                            {t("climate-policy-2.2")}
                            <ul style={{ listStyle: "circle", paddingLeft: "2rem" }}>
                                <li>{t("climate-policy-2.2.1")}</li>
                                <li>{t("climate-policy-2.2.2")}</li>
                                <li>{t("climate-policy-2.2.3")}</li>
                            </ul>
                        </li>
                        <li>{t("climate-policy-2.3")}</li>
                    </ul>


                    <p>
                        <br />
                        <strong style={{ textAlign: "start" }}>{t("climate-policy-title-3")}</strong>
                    </p>

                    <br />
                    <ul style={{ listStyle: "inside" }}>
                        <li>{t("climate-policy-3.1")}</li>
                        <li>
                            {t("climate-policy-3.2")}

                        </li>
                        <li>{t("climate-policy-3.3")}</li>
                        <li>{t("climate-policy-3.4")}</li>
                    </ul>

                    <p>
                        <br />
                        <strong style={{ textAlign: "start" }}>{t("climate-policy-title-4")}</strong>
                    </p>

                    <br />
                    <ul style={{ listStyle: "inside" }}>
                        <li>{t("climate-policy-4.1")}</li>
                        <li>
                            {t("climate-policy-4.2")}
                            <ul style={{ listStyle: "circle", paddingLeft: "2rem" }}>
                                <li>{t("climate-policy-4.2.1")}</li>
                            </ul>
                        </li>
                        <li>{t("climate-policy-4.3")}</li>
                        <li>{t("climate-policy-4.4")}</li>
                        <li>{t("climate-policy-4.5")}</li>
                    </ul>

                    <p>
                        <br />
                        <strong style={{ textAlign: "start" }}>{t("climate-policy-title-5")}</strong>
                    </p>

                    <br />
                    <ul style={{ listStyle: "inside" }}>
                        <li>{t("climate-policy-5.1")}</li>
                        <li>{t("climate-policy-5.2")}</li>
                        <li>{t("climate-policy-5.3")}</li>
                        <li>{t("climate-policy-5.4")}</li>
                        <li>{t("climate-policy-5.5")}</li>
                        <li>{t("climate-policy-5.6")}</li>
                    </ul>
                    <p>
                        <br />
                        <strong style={{ textAlign: "start" }}>{t("climate-policy-title-6")}</strong>
                    </p>

                    <br />
                    <ul style={{ listStyle: "inside" }}>
                        <li>{t("climate-policy-6.1")}</li>
                        <li>{t("climate-policy-6.2")}</li>
                        <li>{t("climate-policy-6.3")}</li>
                        <li>{t("climate-policy-6.4")}</li>
                        <li>{t("climate-policy-6.5")}</li>
                        <li>{t("climate-policy-6.6")}</li>
                    </ul>

                    <p>
                        <br />
                        <strong style={{ textAlign: "start" }}>{t("climate-policy-title-7")}</strong>
                    </p>

                    <br />
                    <ul style={{ listStyle: "inside" }}>
                        <li>{t("climate-policy-7.1")}</li>
                        <li>{t("climate-policy-7.2")}</li>
                        <li>
                            {t("climate-policy-7.3")}
                            <ul style={{ listStyle: "circle", paddingLeft: "2rem" }}>
                                <li>{t("climate-policy-7.3.1")}</li>
                                <li>{t("climate-policy-7.3.2")}</li>
                                <li>{t("climate-policy-7.3.3")}</li>
                            </ul>
                        </li>
                        <li>{t("climate-policy-7.4")}</li>
                    </ul>

                    <p>
                        <br />
                        <strong style={{ textAlign: "start" }}>{t("climate-policy-title-8")}</strong>
                    </p>

                    <br />
                    <ul style={{ listStyle: "inside" }}>
                        <li>{t("climate-policy-8.1")}</li>
                        <li>{t("climate-policy-8.2")}</li>
                        <li>{t("climate-policy-8.3")}</li>
                        <li>{t("climate-policy-8.4")}</li>
                    </ul>
                    <p>
                        <br />
                        <strong style={{ textAlign: "start" }}>{t("climate-policy-title-9")}</strong>
                    </p>

                    <br />
                    <ul style={{ listStyle: "inside" }}>
                        <li>{t("climate-policy-9.1")}</li>
                        <li>{t("climate-policy-9.2")}</li>
                        <li>{t("climate-policy-9.3")}</li>
                    </ul>
                    <p>
                        <br />
                        <strong style={{ textAlign: "start" }}>{t("climate-policy-title-10")}</strong>
                    </p>

                    <br />
                    <ul style={{ listStyle: "inside" }}>
                        <li>{t("climate-policy-10.1")}</li>
                        <li>{t("climate-policy-10.2")}</li>
                        <li>{t("climate-policy-10.3")}</li>
                        <li>{t("climate-policy-10.4")}</li>
                        <li>{t("climate-policy-10.5")}</li>
                    </ul>

                    <p>
                        <br />
                        {t("climate-policy-11")}
                    </p>
                    <p>

                        {t("climate-policy-12")}
                    </p>
                    <p>

                        {t("climate-policy-13")}
                    </p>

                    <br />
                    <p>04.07.2025</p>

                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                        <div style={{ justifyContent: 'center', alignItems: 'center' }}>
                            <div>
                                <h4>Oğuz ÖZMEN</h4>
                                <p>CEO</p>
                            </div>
                        </div>
                    </div>    



                </div>
                
            </div>
        </div>
    );
};

export default Climate;
